import React from "react";
import styled from "@emotion/styled/macro";
import { Link } from 'react-router-dom';
import { 
    AppBar,
    Container,
    Toolbar,
    Typography,
    Box,
    Button,
    Menu,
    MenuItem,
    IconButton
} from "@mui/material";
import DrawerIcon from '@mui/icons-material/Menu';
import HEADER from "./constants";

const StyledAppBar = styled(AppBar)`
    background-color: white;
    color: black;
`;

const StyledLogoXs = styled.img`
    max-width: 100px;
    max-height: 100px;
    width: auto;
    height: auto;
    transform: translateY(5px);
`;

const StyledLogoMd = styled.img`
    max-width: 80px;
    max-height: 80px;
    width: auto;
    height: auto;
`;

const StyledLogoTypographyXs = styled(Typography)`
    font-family: poppins;
    font-weight: 600;
    flex-grow: 1;
    justify-content: center;
    margin-left: 40px;
`;
const StyledLogoTypographyMd = styled(Typography)`
    font-family: poppins;
    font-weight: bold;
    flex-grow: 3;
`;
const StyledDrawerBox = styled(Box)`
    flex-grow: 0;
`;
const StyledDrawerMenu = styled(Menu)`
    font-family: poppins;
`;
const StyledDrawerMenuItem = styled(MenuItem)`
    text-align: center;
`;
const StyledDrawerButton = styled(IconButton)`
`;
const StyledDrawerTypography = styled(Typography)`
    text-align: center;
    font-family: poppins;
`;
const StyledNavBox = styled(Box)`
    flex-grow: 0;
`;
const StyledNavButton = styled(Button)`
    display: block;
    font-family: poppins;
    color: gray;
    border-bottom-color: lightgray;
    &:hover {
        color: black;
        border-bottom: 1px solid lightgray;
    }
`;
const StyledLink = styled(Link)`
    text-decoration: none;
    font-family: poppins;
    font-weight: bold;
    color: black;
    flex-grow: 3;
`;

const Header = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenDrawerMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    }

    const handleCloseDrawerMenu = () => {
        setAnchorElNav(null);
    }

    const handleLogoClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    return ( 
        <StyledAppBar position="sticky">
            <Container maxWidth="x1">
                <Toolbar disableGutters>
                    <StyledLogoTypographyXs variant="h5" noWrap sx={{display: {xs: 'flex', md: 'none'}}}>
                        <Link to="/" onClick={handleLogoClick}>
                            <StyledLogoXs src={HEADER.LOGOS.LOGO} alt="logo of keane's portfolio"/>
                        </Link>
                    </StyledLogoTypographyXs>
                    <Typography sx={{display: {xs: 'none', md: 'flex'}}}>
                        <StyledLink to="/" onClick={handleLogoClick}>
                            <StyledLogoMd src={HEADER.LOGOS.LOGO_NO_TEXT} alt="logo of keane's portfolio without text"/>
                        </StyledLink>
                    </Typography>
                    <StyledLogoTypographyMd variant="h6" noWrap sx={{display: {xs: 'none', md: 'flex'}}}>
                        <StyledLink to="/" onClick={handleLogoClick}>
                            Keane
                        </StyledLink>
                    </StyledLogoTypographyMd>
                    <StyledDrawerBox sx={{display: {xs: 'flex', md: 'none'}}}>
                        <StyledDrawerMenu 
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseDrawerMenu}
                            sx={{ display: {xs: 'block', md:'none'}}}
                        >
                            {HEADER.NAV_ITEMS.map((item) => (
                                <StyledDrawerMenuItem key={item.page} onClick={handleCloseDrawerMenu} component={Link} to={item.link}>
                                    <StyledDrawerTypography>{item.page}</StyledDrawerTypography>
                                </StyledDrawerMenuItem>
                            ))}
                        </StyledDrawerMenu>
                    </StyledDrawerBox>
                    <StyledNavBox sx={{display: {xs: 'none', md: 'flex'}}}>
                        {HEADER.NAV_ITEMS.map((item) => (
                            <StyledNavButton key={item.page} component={Link} to={item.link}>
                                    {item.page}
                            </StyledNavButton>
                        ))}
                    </StyledNavBox>
                    <StyledDrawerBox sx={{display: {xs: 'flex', md: 'none'}}}>
                        <StyledDrawerButton aria-haspopup="true" onClick={handleOpenDrawerMenu}>
                            <DrawerIcon />
                        </StyledDrawerButton>
                    </StyledDrawerBox>
                </Toolbar>
            </Container>
        </StyledAppBar>
    );
}


 
export default Header;